exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tr-whole-border th[data-v-1449ed5e]{padding:12px 6px}.many-field-tr td[data-v-1449ed5e]{padding:6px}.lp-form-type[data-v-1449ed5e]{color:#787878;display:table-cell;font-size:.8rem}.table-cell[data-v-1449ed5e]{text-align:left;width:100%}.est-title[data-v-1449ed5e]{padding-bottom:12px}.est-content[data-v-1449ed5e]{font-size:.9rem}.btn-confirm[data-v-1449ed5e],.btn-process[data-v-1449ed5e],.btn-success[data-v-1449ed5e]{color:#fff}.btn-confirm[data-v-1449ed5e]{background-color:#ffc107}.btn-process[data-v-1449ed5e]{background-color:#4dbd74}.btn-success[data-v-1449ed5e]{background-color:#fd7014}", ""]);

// exports
